module.exports = __webpack_public_path__ + "media/images/front/pc/institution-search/body-8bb817778190a6519069d30136e3e188.svg";